var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.data.state,{tag:"component",attrs:{"data":_vm.data,"type":_vm.type},model:{value:(_vm.setValue),callback:function ($$v) {_vm.setValue=$$v},expression:"setValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }